<template>
    <div id="PatientNotificationList">
        <BaseView :PatientCode="$route.params.id" :MdTitle="$t('Shared.Notices')" @getVisibleMenu="$emit('getVisibleMenu', $event)">
            <template v-slot:content>
               <Notifications
                    :IsFilterPatient="false"
                    :IsFilterRecipientType="false"
                    :IsFilterModule="false"
                    :IsFilterAction="false"
                    :PatientCode="$route.params.id">
                </Notifications>
            </template>
        </BaseView>
    </div>
</template>

<script>
import Notifications from '@/components/MedEZComponents/Notices/Notices.vue';

export default {
  name: 'NotificationList',
  props:{

  },
  components:{Notifications},
  data(){
    return {

    }
  },

  computed:{

  },

  methods:{

  },

  created(){

  },

  mounted(){

  }

};
</script>


